import moment from 'moment';

export const getEndDate = (startDate, frequency, checkedDays) => {
  let current = moment(startDate);
  const daysToAdd = frequency * 7;
  let endDate = moment(current).add(daysToAdd, 'days');

  // Adjust end date based on checked days
  while (!checkedDays[endDate.day()]) {
    endDate.add(1, 'day');
  }

  return formatDateISO(endDate);
};

export const validateBookingForm = (area, desk, checkedDays, startDate, endDate) => {
  const formErrors = {};
  if (!area) {
    formErrors['area'] = 'Please select an area';
  }
  if (!desk) {
    formErrors['desk'] = 'Please select a desk. A selected desk is shown in orange.';
  }
  if (checkedDays.every(day => !day)) {
    formErrors['days'] = 'Select at least one day.';
  }

  const maxAllowedDate = getMaxDate();
  if (moment(formatDateISO(endDate), 'YYYY-MM-DD').isAfter(maxAllowedDate)) {
    formErrors['endDate'] = `Latest allowed End Date: ${formatDateUI(maxAllowedDate)}.`;
  }

  return formErrors;
};

export const validateAdminBookingForm = (area, desk, checkedDays, email, endDate) => {
  const errors = {};
  if (!area) {
    errors['area'] = 'Please select an area';
  }
  if (!desk) {
    errors['desk'] = 'Please select a desk. A selected desk is shown in orange.';
  }
  if (checkedDays.every(day => !day)) {
    errors['days'] = 'Select at least one day.';
  }
  if (!email) {
    errors['email'] = 'Provide a Name or E-Mail-Address.';
  }

  const maxAllowedDate = getMaxDate();
  if (moment(formatDateISO(endDate), 'YYYY-MM-DD').isAfter(maxAllowedDate)) {
    errors['endDate'] = `Latest allowed End Date: ${formatDateUI(maxAllowedDate)}.`;
  }

  return errors;
};

export const validateAdminSingleBookingForm = (desk, email) => {
  const errors = {};
  if (!desk) {
    errors['desk'] = 'Please select a desk. A selected desk is shown in orange.';
  }
  if (!email) {
    errors['email'] = 'Provide a Name or E-Mail-Address.';
  }
  return errors;
};

export const prepareBookingRequests = (username, tableId, bookingDate, allBookings, comment) => {
  const requests = [];
  const bookingErrors = [];

  const detectedFormat = detectDateFormat(bookingDate);
  let parsedBookingDate;

  if (detectedFormat) {
    parsedBookingDate = formatDateISO(bookingDate);
  } else {
    bookingErrors.push('Invalid date format.');
    return { requests, bookingErrors };
  }

  // Proceed with parsedBookingDate
  const conflictingBooking = allBookings.find(b => {
    return b.username === username &&
      formatDateISO(b.date) === parsedBookingDate;
  });

  let conflictingBookingTable = allBookings.find(b =>
    b.deskid === parseInt(tableId) &&
    formatDateISO(moment(b.date)) === parsedBookingDate
  );

  if (conflictingBooking) {
    bookingErrors.push(`Booking conflict for ${formatDateUI(parsedBookingDate)} with ${conflictingBooking.username}.`);
  } else if (conflictingBookingTable) {
    bookingErrors.push(`Booking conflict for ${formatDateUI(parsedBookingDate)} with ${conflictingBookingTable.username}.`);
  } else {
    requests.push({
      username,
      deskid: tableId,
      date: parsedBookingDate,
      lastModifiedBy: username,
      bookedBy: username,
      comment: comment,
    });
  }

  return { requests, bookingErrors };
};

export const formatDateISO = (date) => {
  const detectedFormat = detectDateFormat(date);
  if (detectedFormat === moment.ISO_8601 || detectedFormat === 'YYYY-MM-DD') {
    return moment(date).format('YYYY-MM-DD');
  } else if (detectedFormat === 'DD.MM.YYYY') {
    return moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD');
  } else if (detectedFormat === 'MM/DD/YYYY') {
    return moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD');
  }
  // Handle unknown format as needed
  return null;
};

export const formatDateUI = (date) => {
  const detectedFormat = detectDateFormat(date);
  if (detectedFormat === moment.ISO_8601 || detectedFormat === 'YYYY-MM-DD') {
    return moment(date).format('DD.MM.YYYY');
  } else if (detectedFormat === 'DD.MM.YYYY') {
    return moment(date, 'DD.MM.YYYY').format('DD.MM.YYYY');
  } else if (detectedFormat === 'MM/DD/YYYY') {
    return moment(date, 'MM/DD/YYYY').format('DD.MM.YYYY');
  }
  // Handle unknown format as needed
  return null;
};

export const prepareBookingRequestsForAdmin = (username, tableId, bookingDate, allBookings, comment, adminUser) => {
  const requests = [];
  const bookingErrors = [];

  const formattedBookingDate = formatDateISO(moment(bookingDate));

  let conflictingBookingTable = allBookings.find(b =>
    b.deskid === parseInt(tableId) &&
    formatDateISO(moment(b.date)) === formattedBookingDate

  );

  if (conflictingBookingTable) {
    bookingErrors.push(`Booking conflict for ${formatDateUI(formattedBookingDate)} with ${conflictingBookingTable.username}.`);
  } else {

    requests.push({
      username,
      deskid: tableId,
      date: formattedBookingDate,
      lastModifiedBy: adminUser,
      bookedBy: adminUser,
      comment: comment,
      isAdminBookingType: 1
    });

  }

  return { requests, bookingErrors };
};

/**
 * Detects the format of a given date string.
 *
 * @param {string} dateStr - The date string to check.
 * @returns {string|null} - The detected format or null if no match.
 */
export const detectDateFormat = (dateStr) => {
  const formats = [
    moment.ISO_8601,
    'DD.MM.YYYY',
    'MM/DD/YYYY',
    'YYYY-MM-DD',
  ];

  for (let format of formats) {
    if (moment(dateStr, format, true).isValid()) {
      return format;
    }
  }

  return null; // Unknown format
};

export const getMaxDate = () => {
  return moment()
    .add(26, 'weeks')
    .toDate();
};
